import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/GetAutoManagedCampaignsCount.graphql';
import { Query, QuerygetAutoManagedCampaignsCountArgs } from '../../__generated__/globalTypes';

export const useGetAutoManagedCampaignsCountQuery = (
  options?: QueryHookOptions<Query, QuerygetAutoManagedCampaignsCountArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerygetAutoManagedCampaignsCountArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useGetAutoManagedCampaignsCountLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerygetAutoManagedCampaignsCountArgs>
): QueryResult<Query, QuerygetAutoManagedCampaignsCountArgs> & {
  getGetAutoManagedCampaignsCount: LazyQueryExecFunction<Query, QuerygetAutoManagedCampaignsCountArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getGetAutoManagedCampaignsCount, result] = useLazyQuery<Query, QuerygetAutoManagedCampaignsCountArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getGetAutoManagedCampaignsCount, ...result };
};

export const useGetAutoManagedCampaignsCountPromiseQuery = () => {
  const client = useApolloClient();

  const getGetAutoManagedCampaignsCount = useCallback(
    (options?: Omit<QueryOptions<QuerygetAutoManagedCampaignsCountArgs, Query>, 'query'>) =>
      client.query<Query, QuerygetAutoManagedCampaignsCountArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getGetAutoManagedCampaignsCount };
};
// Suspense Query Hooks
export const useGetAutoManagedCampaignsCountSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerygetAutoManagedCampaignsCountArgs>
) => {
  const result = useSuspenseQuery<Query, QuerygetAutoManagedCampaignsCountArgs>(QUERY, {
    ...options
  });

  return result;
};
